import React from 'react';
import { SubheadingBlock } from '../SubheadingBlock';
import { IconAndTitle } from '../../shared/IconAndTitle';
import { HydratedBlockProps } from '../../BaseBlock';

export type SubheadingEditorSettingsProps = {
  block: SubheadingBlock & HydratedBlockProps;
};

export function SubheadingEditorSettings({
  block,
}: SubheadingEditorSettingsProps): JSX.Element {
  return (
    <>
      <IconAndTitle icon={block.icon} title={block.title} />
      <hr />
    </>
  );
}
